export const cloneArray = (input) => {
  if (Array.isArray(input)) {
    return input.map((item) => {
      if (item && typeof item === 'object') {
        return { ...item }
      }

      return item
    })
  }

  return []
}
